export const CONTENTFUL_IMAGE = 'contentful-image'
